import { useMyStore } from "src/components/main/mainStore";
import { ReactComponent as ResizeIcon } from "src/img/svg/resize.svg";

export default function Resize(){
    const mainMenuStyle = useMyStore(state => state.mainMenuStyle);
    const setMainMenuStyle = useMyStore(state => state.setMainMenuStyle);
    const mapFull = useMyStore(state => state.mapFull);
    const setMapFull = useMyStore(state => state.setMapFull);
    const handleResize = () => {
        if(window.innerWidth > 960){
            if(mainMenuStyle && mainMenuStyle.flex === "0 0 0"){
                setMapFull(!mapFull);
                setMainMenuStyle({});
                //document.querySelector(".leaflet-container").style = null;
            }else{
                setMainMenuStyle({flex: "0 0 0", marginLeft: 0, marginRight: 0});
                setTimeout(() => {
                    setMapFull(!mapFull);
                }, 600 /* after transition duration*/);
            }
        }
    }
    return (
        <span className = "mr-2">
            <button
                type = "button"
                className = "noButtonStyle" 
                onClick = {e => {
                    (e.currentTarget.childNodes[0] as HTMLOrSVGImageElement).classList.toggle("resizeRotate");
                    handleResize();
                }}
            >
                <ResizeIcon className = "resizeStyle"/>
            </button>
        </span>
    );
}